/* pp-header.js - moved out of sections/pp-header.liquid on 2026-09-05 (pp-lcp): this used to run inline in the header group,
   before the page content had even been parsed. As a deferred asset it runs after parsing and is cached across pages. */
(function(){
var hdr = document.getElementById('hdr');
addEventListener('scroll', function(){ hdr.classList.toggle('scrolled', scrollY > 12); }, {passive:true});
var mega = document.getElementById('mega');
var megabody = document.getElementById('megabody');
var navBtns = Array.prototype.slice.call(document.querySelectorAll('.navlink[data-menu]'));
var curKey = null, closeT = null, settleT = null;
function openMenu(key){
  clearTimeout(closeT);
  var panel = document.querySelector('.panel[data-panel="' + key + '"]');
  if (!panel || curKey === key) return;
  var prev = document.querySelector('.panel.act');
  if (prev){
    var h0 = prev.offsetHeight;
    prev.classList.remove('act');
    panel.classList.add('act');
    var h1 = panel.offsetHeight;
    clearTimeout(settleT);
    megabody.style.height = h0 + 'px';
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ megabody.style.height = h1 + 'px'; }); });
    settleT = setTimeout(function(){ if (curKey === key) megabody.style.height = 'auto'; }, 380);
  } else {
    panel.classList.add('act');
    megabody.style.height = 'auto';
  }
  hdr.classList.add('menuopen');
  curKey = key;
  navBtns.forEach(function(b){
    var active = b.dataset.menu === key;
    b.classList.toggle('cur', active);
    b.setAttribute('aria-expanded', String(active));
  });
}
function closeMenu(now){
  clearTimeout(closeT);
  closeT = setTimeout(function(){
    hdr.classList.remove('menuopen');
    var act = document.querySelector('.panel.act');
    if (act) act.classList.remove('act');
    navBtns.forEach(function(b){
      b.classList.remove('cur');
      b.setAttribute('aria-expanded', 'false');
    });
    megabody.style.height = '';
    curKey = null;
  }, now ? 0 : 170);
}
navBtns.forEach(function(b){
  b.addEventListener('mouseenter', function(){ openMenu(b.dataset.menu); });
  b.addEventListener('mouseleave', function(){ closeMenu(); });
  b.addEventListener('click', function(e){
    /* A pointer click follows mouseenter, which has already opened this
       panel. Keep it open instead of immediately toggling it closed. */
    if (e.detail > 0){ openMenu(b.dataset.menu); return; }
    if (curKey === b.dataset.menu && hdr.classList.contains('menuopen')) closeMenu(true);
    else openMenu(b.dataset.menu);
  });
});
mega.addEventListener('mouseenter', function(){ clearTimeout(closeT); });
mega.addEventListener('mouseleave', function(){ closeMenu(); });
addEventListener('click', function(e){ if (!mega.contains(e.target) && !e.target.closest('.navlink')) closeMenu(true); });
addEventListener('keydown', function(e){
  if (e.key !== 'Escape') return;
  closeMenu(true);
  if (drawer && drawer.classList.contains('open')) toggleDrawer(false, true);
});
var burger = document.getElementById('burger'), drawer = document.getElementById('drawer');
function setDrawerTop(){ drawer.style.top = Math.max(hdr.getBoundingClientRect().bottom, 0) + 'px'; }
function toggleDrawer(open, restoreFocus){
  if (open === undefined) open = !drawer.classList.contains('open');
  if (open) setDrawerTop();
  drawer.classList.toggle('open', open);
  burger.classList.toggle('x', open);
  burger.setAttribute('aria-expanded', String(open));
  burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  drawer.setAttribute('aria-hidden', String(!open));
  drawer.inert = !open;
  document.documentElement.style.overflow = open ? 'hidden' : '';
  if (open){
    requestAnimationFrame(function(){ var first = drawer.querySelector('a'); if (first) first.focus(); });
  } else if (restoreFocus){
    burger.focus();
  }
}
burger.addEventListener('click', function(){ toggleDrawer(); });
addEventListener('resize', function(){
  if (!drawer.classList.contains('open')) return;
    if (innerWidth > 1280) toggleDrawer(false); else setDrawerTop();
});
drawer.addEventListener('click', function(e){ if (e.target.closest('a')) toggleDrawer(false); });
drawer.addEventListener('keydown', function(e){
  if (e.key !== 'Tab' || !drawer.classList.contains('open')) return;
  var focusable = Array.prototype.slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(el){
    return el.offsetParent !== null;
  });
  if (!focusable.length){ e.preventDefault(); burger.focus(); return; }
  var first = focusable[0], last = focusable[focusable.length - 1];
  if (e.shiftKey && document.activeElement === first){
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last){
    e.preventDefault();
    first.focus();
  }
});
})();
(function(){
  var logo = document.getElementById('logoEl');
  var spacer = null, dragging = false, wasThrown = false;
  var px = 0, py = 0, vx = 0, vy = 0, ang = 0, va = 0, w = 0, h = 0;
  var lastX = 0, lastY = 0, lastT = 0, rafId = null, flightStart = 0;
  var GRAV = 2600, REST = .74, FRICT = .988;
  function place(){ logo.style.left = px + 'px'; logo.style.top = py + 'px'; logo.style.transform = 'rotate(' + ang + 'deg)'; }
  function detach(){
    var r = logo.getBoundingClientRect();
    w = r.width; h = r.height;
    spacer = document.createElement('span');
    spacer.style.cssText = 'display:inline-block;width:' + w + 'px;height:' + h + 'px;margin-right:16px;flex-shrink:0';
    logo.parentNode.insertBefore(spacer, logo);
    px = r.left; py = r.top; ang = 0; va = 0;
    logo.classList.add('held');
    place();
  }
  function restore(){
    logo.classList.remove('held','free','carried');
    logo.style.left = logo.style.top = logo.style.transform = '';
    if (spacer) spacer.remove(); spacer = null;
    logo.classList.add('wobble');
    setTimeout(function(){ logo.classList.remove('wobble'); }, 600);
  }
  logo.addEventListener('pointerdown', function(e){
    if (logo.classList.contains('carried')) return;
    e.preventDefault();
    cancelAnimationFrame(rafId);
    if (!spacer) detach(); else logo.classList.replace('free','held');
    dragging = true; wasThrown = false;
    lastX = e.clientX; lastY = e.clientY; lastT = performance.now();
    vx = vy = 0;
    logo.setPointerCapture(e.pointerId);
  });
  logo.addEventListener('pointermove', function(e){
    if (!dragging) return;
    var now = performance.now(), dt = Math.max((now - lastT) / 1000, .001);
    var dx = e.clientX - lastX, dy = e.clientY - lastY;
    if (Math.abs(dx) + Math.abs(dy) > 2) wasThrown = true;
    vx = vx * .5 + (dx / dt) * .5;
    vy = vy * .5 + (dy / dt) * .5;
    px += dx; py += dy;
    ang = Math.max(-14, Math.min(14, vx * .012));
    lastX = e.clientX; lastY = e.clientY; lastT = now;
    place();
  });
  logo.addEventListener('pointerup', function(){
    if (!dragging) return;
    dragging = false;
    if (!wasThrown) { restore(); return; }
    logo.classList.replace('held','free');
    flightStart = performance.now();
    var prev = performance.now();
    function fly(){
      var now = performance.now(), dt = Math.min((now - prev) / 1000, .033); prev = now;
      vy += GRAV * dt; vx *= FRICT;
      px += vx * dt; py += vy * dt;
      va = va * .98 + vx * .00045;
      ang += va * dt * 60;
      var W = innerWidth, H = innerHeight;
      var bounced = false;
      if (px < 0){ px = 0; vx = -vx * REST; bounced = true; }
      if (px + w > W){ px = W - w; vx = -vx * REST; bounced = true; }
      if (py < 0){ py = 0; vy = -vy * REST; bounced = true; }
      if (py + h > H){ py = H - h; vy = -vy * REST; vx *= .92; va = vx * .002; bounced = true; }
      if (bounced){
        logo.style.transition = 'scale .09s';
        logo.style.scale = '1.08 0.88';
        setTimeout(function(){ logo.style.scale = '1'; }, 90);
      }
      place();
      var grounded = py + h > H - 2 && Math.abs(vy) < 130 && Math.abs(vx) < 90;
      if (grounded || now - flightStart > 6000) stickmanReturn();
      else rafId = requestAnimationFrame(fly);
    }
    rafId = requestAnimationFrame(fly);
  });
  logo.addEventListener('click', function(e){ if (wasThrown || spacer) e.preventDefault(); });
  function stickmanReturn(){
    logo.classList.remove('free');
    logo.classList.add('carried');
    logo.style.scale = '';
    var W = innerWidth, H = innerHeight;
    py = H - h; ang = 0; place();
    var man = document.createElement('div');
    man.id = 'stickman';
    man.innerHTML = '<svg class="rig" width="34" height="54" viewBox="0 0 34 54">' +
      '<circle cx="17" cy="8" r="6"/>' +
      '<line x1="17" y1="14" x2="17" y2="33"/>' +
      '<line class="limb a1" x1="17" y1="19" x2="8" y2="28"/>' +
      '<line class="limb a2" x1="17" y1="19" x2="26" y2="28"/>' +
      '<line class="limb l1" x1="17" y1="33" x2="10" y2="50"/>' +
      '<line class="limb l2" x1="17" y1="33" x2="24" y2="50"/></svg>';
    document.body.appendChild(man);
    var mw = 34, mh = 54;
    var fromRight = px + w / 2 < W / 2;
    var mx = fromRight ? W + 50 : -70;
    var my = H - mh - 2;
    var face = fromRight ? -1 : 1;
    var mrot = 0;
    function setMan(){ man.style.transform = 'translate(' + mx + 'px,' + my + 'px) rotate(' + mrot + 'deg) scaleX(' + face + ')'; }
    setMan();
    requestAnimationFrame(function(){ man.classList.add('show', 'walk'); });
    function homeRect(){ return spacer.getBoundingClientRect(); }
    var legs = [
      {tx: function(){ return px + (fromRight ? w + 8 : -mw - 8); }, ty: function(){ return H - mh - 2; }, carry: false},
      {tx: function(){ return 12; }, ty: function(){ return H - mh - 2; }, carry: true},
      {tx: function(){ return 12; }, ty: function(){ return homeRect().top + 4; }, carry: true, climb: true},
      {tx: function(){ return homeRect().left + 30; }, ty: function(){ return homeRect().top + 4; }, carry: true}
    ];
    var li = 0, prevT = performance.now();
    var SPEED = .5;
    function walk(now){
      var dt = Math.min(now - prevT, 50); prevT = now;
      var leg = legs[li];
      var tx = leg.tx(), ty = leg.ty();
      var dx = tx - mx, dy = ty - my;
      var dist = Math.hypot(dx, dy);
      var step = Math.min(SPEED * dt, dist);
      if (dist > 0){ mx += dx / dist * step; my += dy / dist * step; }
      if (Math.abs(dx) > 2) face = dx > 0 ? 1 : -1;
      if (leg.climb){ face = 1; mrot = 90; } else { mrot = 0; }
      setMan();
      if (leg.carry){
        var wob = Math.sin(now * .02) * 3;
        if (leg.climb){ px = mx + 24; py = my + 12; ang = 8 + wob; }
        else if (li === 3){ px = mx + 26; py = my + 14; ang = 4 + wob; }
        else { px = mx + (face === 1 ? -w + 6 : mw - 8); py = H - h - 4; ang = (face === 1 ? -9 : 9) + wob; }
        place();
      }
      if (dist <= 1){
        li++;
        if (li === 1){
          man.classList.remove('walk');
          man.classList.add('carry');
          setTimeout(function(){ man.classList.add('walk'); prevT = performance.now(); requestAnimationFrame(walk); }, 340);
          return;
        }
        if (li >= legs.length){ deliver(); return; }
      }
      requestAnimationFrame(walk);
    }
    requestAnimationFrame(walk);
    function deliver(){
      man.classList.remove('walk', 'carry');
      var hr = homeRect();
      var t0 = performance.now(), sx0 = px, sy0 = py, sa0 = ang;
      function slot(now){
        var t = Math.min((now - t0) / 300, 1), e = 1 - Math.pow(1 - t, 3);
        px = sx0 + (hr.left - sx0) * e; py = sy0 + (hr.top - sy0) * e; ang = sa0 * (1 - e);
        place();
        if (t < 1) requestAnimationFrame(slot);
        else {
          restore();
          man.classList.add('joy');
          setTimeout(function(){ man.classList.remove('show'); setTimeout(function(){ man.remove(); }, 350); }, 1000);
        }
      }
      requestAnimationFrame(slot);
    }
  }
})();
